import * as SubframeCore from "@subframe/core";
import {
  NOTIFYER_MONDAY_DOCS_OVERVIEW_URL,
  NOTIFYER_MONDAY_OVERVIEW_VIDEO_URL,
} from "../constants/notifyerHelpLinks";

/**
 * Thin app-wide strip: docs + overview video (auth, WhatsApp, chat).
 * Stays visually separate from the chat pane.
 */
export function NotifyerHelpLinksBar() {
  const linkBase =
    "inline-flex items-center gap-1 text-caption font-caption text-subtext-color transition-colors hover:text-default-font underline-offset-2 hover:underline";

  return (
    <nav
      className="flex h-8 w-full shrink-0 flex-wrap items-center justify-center gap-x-5 gap-y-0.5 border-b border-solid border-neutral-border bg-neutral-50/60 px-3 dark:bg-neutral-900/40"
      aria-label="Notifyer documentation and overview video"
    >
      <a
        href={NOTIFYER_MONDAY_DOCS_OVERVIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={linkBase}
      >
        <SubframeCore.Icon name="FeatherBookOpen" className="h-3.5 w-3.5" />
        Documentation
      </a>
      <a
        href={NOTIFYER_MONDAY_OVERVIEW_VIDEO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={linkBase}
      >
        <SubframeCore.Icon name="FeatherPlayCircle" className="h-3.5 w-3.5" />
        Overview video
      </a>
    </nav>
  );
}
